import React from 'react';
import Checkbox from 'material-ui/Checkbox';
import MenuItem from 'material-ui/MenuItem';
import styled from 'styled-components';
import { Box } from 'grid-styled';
// import { map, values } from 'ramda';
import { values } from 'ramda';
import { func, bool, oneOf } from 'prop-types';

import {
  ExportFileFormat,
  ExportSource,
  ExportTimeSource,
} from '../../constants';
import DropDownTitled from './../DropDownTitled';
// import FilteredCrimeCount, { TotalCrimeCount } from '../CrimeCount';

/*
 * We use combination of negative and positive margins
 * to make it possible to do 100% width horizontal lines
 * in future versions of this dialog.
 */
const Container = styled.div`
  font-size: 14px;
  margin: 0px -24px -24px -24px;
`;

const TitleTextBlock = styled.div`
  color: black;
  font-size: 15px;
  line-height: ${({ theme }) => theme.lineHeight};
`;

const DividedBlock = styled.div`
  padding: 0px 24px 24px 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey300};
`;

const TermsBlock = styled.div`
  font-size: 12px;
  line-height: 14px;
  margin-top: 20px;
`;

export const CustomDropDown = ({
  title,
  value,
  onChange,
  items,
  labels = {},
}) => (
  <DropDownTitled
    value={value}
    onChange={(e, i, val) => onChange(val)}
    title={title}
    style={{ minWidth: 160 }}
    menuStyle={{ minWidth: 120 }}
  >
    {Object.entries(items).map(([key, val]) => (
      <MenuItem key={key} value={val} primaryText={labels[key] || val} />
    ))}
  </DropDownTitled>
);

export const DataExport = ({
  censusView,
  includeDataset,
  fileFormat,
  exportSource,
  timeSource,
  includeMetadata,
  agreedToTerms,
  setIncludeDataset,
  setFileFormat,
  setExportSource,
  setTimeSource,
  setIncludeMetadata,
  setAgreedToTerms,
}) => {
  // const locations = censusView ? 'Census Tracts' : 'Cities';
  const labelText =
    'By cicking export you agree to the following: a) The data will not be ' +
    'distributed without permission; b) All publications and reports must ' +
    'include the following citation: Sharkey, Patrick. ' +
    '"AmericanViolence.org: Level of data [City or tract], Type of data ' +
    '[Murder, Fatal shootings, or Nonfatal shootings]. Princeton, NJ.: ' +
    'www.americanviolence.org"';

  return (
    <Container>
      <DividedBlock>
        <TitleTextBlock>
          <span>
            {/*{'Export '}*/}
            {/*{exportSource === ExportSource.ALL ? (*/}
            {/*  <TotalCrimeCount noCapitalization />*/}
            {/*) : (*/}
            {/*  <FilteredCrimeCount noCapitalization />*/}
            {/*)}*/}
          </span>
        </TitleTextBlock>
        <Box pt={22}>
          <Checkbox
            label="Dataset"
            onCheck={(_, value) => setIncludeDataset(value)}
            checked={includeDataset}
          />
        </Box>
        <Box pl={41} pt={11}>
          <CustomDropDown
            title="File format:"
            value={fileFormat}
            onChange={value => setFileFormat(value)}
            items={ExportFileFormat}
          />
        </Box>
        <Box pl={41} pt={17}>
          {/*<CustomDropDown*/}
          {/*  title={locations + ':'}*/}
          {/*  value={exportSource}*/}
          {/*  onChange={value => setExportSource(value)}*/}
          {/*  items={ExportSource}*/}
          {/*  labels={map(item => `${item} ${locations}`, ExportSource)}*/}
          {/*/>*/}
          <CustomDropDown
            title="Time interval:"
            value={timeSource}
            onChange={value => setTimeSource(value)}
            items={ExportTimeSource}
          />
        </Box>
        <Box pt={20}>
          <Checkbox
            label="Include metadata file"
            onCheck={(_, value) => setIncludeMetadata(value)}
            checked={includeMetadata}
          />
        </Box>
        <TermsBlock>
          <Checkbox
            label={labelText}
            onCheck={(_, value) => setAgreedToTerms(value)}
            checked={agreedToTerms}
          />
        </TermsBlock>
      </DividedBlock>
    </Container>
  );
};

DataExport.propTypes = {
  censusView: bool.isRequired,
  includeDataset: bool.isRequired,
  fileFormat: oneOf(values(ExportFileFormat)).isRequired,
  exportSource: oneOf(values(ExportSource)).isRequired,
  timeSource: oneOf(values(ExportTimeSource)).isRequired,
  includeMetadata: bool.isRequired,
  setIncludeDataset: func.isRequired,
  setFileFormat: func.isRequired,
  setExportSource: func.isRequired,
  setTimeSource: func.isRequired,
  setIncludeMetadata: func.isRequired,
};

export default DataExport;



// WEBPACK FOOTER //
// ./src/components/DataExport/DataExport.jsx